var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "url(#paint0_linear_65_398)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8996 30.64V16.7142H10.273V30.64H14.8996ZM12.5869 14.8118C14.2003 14.8118 15.2045 13.7424 15.2045 12.4061C15.1745 11.0397 14.2003 10 12.6175 10C11.0349 10 10 11.0397 10 12.4061C10 13.7425 11.004 14.8118 12.5567 14.8118H12.5869ZM17.4604 30.64H22.087V22.8632C22.087 22.4469 22.117 22.0312 22.2392 21.7337C22.5737 20.9021 23.3349 20.0408 24.613 20.0408C26.2872 20.0408 26.9569 21.3179 26.9569 23.1899V30.6399H31.5832V22.655C31.5832 18.3775 29.3007 16.3873 26.2567 16.3873C23.7608 16.3873 22.665 17.783 22.0562 18.7336H22.0871V16.7139H17.4605C17.5212 18.0207 17.4604 30.64 17.4604 30.64Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_398",
    x1: 0,
    y1: 20.5,
    x2: 41,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18669C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2596A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.f47f910278763b20c5feef37a52f4e8c.svg";
export { ForwardRef as ReactComponent };